var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchFieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SearchFieldIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-field",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-9.000000, -7.000000)",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#848484",
    fillRule: "nonzero",
    id: "SearchFieldIcon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6121739,7.00726957 C18.109136,7.00382432 20.3942391,8.40987792 21.5166357,10.6403615 C22.6390324,12.8708451 22.4065113,15.5437868 20.9158261,17.5469565 L24.483513,20.5645913 C24.8736804,20.8975571 25.0440074,21.4212968 24.9243326,21.92007 C24.8046577,22.4188431 24.4152258,22.8082751 23.9164526,22.92795 C23.4176794,23.0476248 22.8939397,22.8772978 22.5609739,22.4871304 L19.5426087,18.92 C17.2369926,20.6288033 14.0918274,20.6534587 11.7597052,18.9810113 C9.42758292,17.3085639 8.44210204,14.321676 9.32107247,11.5897746 C10.2000429,8.85787316 12.7423528,7.00602762 15.6121739,7.00726957 Z M15.6121739,18.8333565 C18.4936596,18.8333565 20.8295652,16.4974509 20.8295652,13.6159652 C20.8295652,10.7344796 18.4936596,8.39857391 15.6121739,8.39857391 C12.7306883,8.39857391 10.3947826,10.7344796 10.3947826,13.6159652 C10.3948018,16.4974373 12.7307018,18.8333217 15.6121739,18.8333217 L15.6121739,18.8333565 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFieldIcon);
export default __webpack_public_path__ + "static/media/SearchFieldIcon.8a48f25f0ed57c1cfbd864fc7686e89c.svg";
export { ForwardRef as ReactComponent };